exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.embedded-view[data-v-49c34af3] {\n  min-height: 100vh;\n  background: #fff;\n}\n.embedded-loading[data-v-49c34af3] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  min-height: 200px;\n  color: #636b6f;\n  font-size: 14px;\n}\r\n", ""]);

// exports
